export const FeatureFlags = Object.freeze({
  // Add your feature flags here

  // HELLO_WORLD_FEATURE: 'hello-world-feature',
  BATCH_ANALYSIS: 'batch-analysis',
  AWARENESS_TAB: 'awareness-tab',
  LOAD_PLANNING_MEASURE_SIMULATION: 'measure-simulation-load-planning',
  PROCUREMENT_UPSELLING: 'procurement-upselling',
  SAVINGS_CUSTOM_REFERENCE_PRICE: 'custom-reference-price-in-savings-modal',
  LANGUAGE_SELECTION: 'language-selection',
  LEGACY_INSIGHTS_NAV: 'legacy-insights-nav',
  ENERGY_MARKETS_PAGE_EXTENSION: 'energy-markets-page-extension',
  ATLAS: 'atlas',
  EASY_OFFER_ENPI: 'easy-offer-enpi',
  EASY_OFFER_DASHBOARD: 'easy-offer-dashboard',
  CUSTOM_REFERENCE_BASE_LOAD: 'custom-reference-base-load',
  NEW_INVOICE_COST_CALCULATION: 'new-invoice-cost-calculation',
  AUTOMATED_INSIGHTS: 'automated-insights',
})
